import React, { useMemo } from 'react';

import { directImagesUrl } from '../../../config';

import Options from './options';

import './direct-message-style.css';

function DirectMessage({ admin, member, data, index }) {
  const adminLoggedIn = admin.auth.value;

  const owner = useMemo(() => {
    if (adminLoggedIn) {
      return parseInt(data.admin_id, 10) > 0;
    } else if (member.auth.value) {
      return parseInt(data.admin_id, 10) === 0;
    }

    return false;
  }, [admin, member, data]);

  if (data.type === 'img') {
    return (
      <div
        className={`p-relative f-00auto f-row align-content-stretch ${
          owner ? 'justify-content-end' : 'justify-content-start'
        }`}
      >
        <div className={`p-relative direct-message ${owner ? 'owner' : 'client'}`}>
          <div className="direct-message-body img">
            <div className="message-content image d-flex">
              <img src={directImagesUrl + data.content} alt={data.content} />

              <span className={'time d-inline-block font-size-2'}>{data.time}</span>
            </div>
          </div>

          <Options
            adminLoggedIn={adminLoggedIn}
            clientIsOwner={owner}
            messageId={data.id}
            locked={data.is_lock}
            forLastMessage={index === 0}
            memberId={data.member_id}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`p-relative f-00auto f-row align-content-stretch ${
        owner ? 'justify-content-end' : 'justify-content-start'
      }`}
    >
      <div className={`p-relative direct-message ${owner ? 'owner' : 'client'}`}>
        <div className="direct-message-body">
          <div className="message-content">
            {data.content &&
              data.content.split('\n').map((str, i) => {
                return (
                  <React.Fragment key={str}>
                    {i !== 0 && <br />}
                    {str}
                  </React.Fragment>
                );
              })}
            <span className={'time d-inline-block font-size-2 mr-8p color-gray'}>{data.time}</span>
          </div>
        </div>

        <Options
          adminLoggedIn={adminLoggedIn}
          clientIsOwner={owner}
          messageId={data.id}
          locked={data.is_lock}
          forLastMessage={index === 0}
          memberId={data.member_id}
        />
      </div>
    </div>
  );
}

export default DirectMessage;
